import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

export default function TareaFormModal({ isOpen, onClose, onSave, initialData, seeds, hortelanos = [] }) {
  const [descripcion, setDescripcion] = useState('');
  const [fecha, setFecha] = useState(new Date().toISOString().split('T')[0]);
  const [semillaId, setSemillaId] = useState('');
  const [variedad, setVariedad] = useState('');
  const [asignadoA, setAsignadoA] = useState('');

  useEffect(() => {
    if (isOpen) {
      if (initialData) {
        setDescripcion(initialData.descripcion || '');
        setFecha(initialData.fecha || new Date().toISOString().split('T')[0]);
        setSemillaId(initialData.semilla_id || '');
        setVariedad(initialData.variedad || '');
        setAsignadoA(initialData.asignado_a || '');
      } else {
        setDescripcion('');
        setFecha(new Date().toISOString().split('T')[0]);
        setSemillaId('');
        setVariedad('');
        setAsignadoA('');
      }
    }
  }, [isOpen, initialData]);

  if (!isOpen) return null;

  const selectedSeed = seeds.find(s => s.id === semillaId);

  const handleSave = (e) => {
    e.preventDefault();
    if (!descripcion.trim() || !fecha) return;

    onSave({
      id: initialData?.id,
      descripcion: descripcion.trim(),
      fecha,
      semilla_id: semillaId || null,
      variedad: variedad || null,
      asignado_a: asignadoA || null
    });
  };

  return createPortal(
    <div className="modal-overlay" onClick={(e) => {
      if(e.target.className === 'modal-overlay') onClose();
    }}>
      <div className="modal-content animate-scale">
        <div className="modal-header">
          <h3 style={{ margin: 0 }}>
            {initialData ? 'Editar Tarea' : 'Nueva Tarea'}
          </h3>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSave}>
          <div className="input-group">
            <label htmlFor="tareaDesc">Descripción</label>
            <input 
              type="text" 
              id="tareaDesc"
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              placeholder="Ej. Regar, podar, abonar..."
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="tareaFecha">Fecha Prevista</label>
            <input 
              type="date" 
              id="tareaFecha"
              value={fecha}
              onChange={(e) => setFecha(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="tareaSemilla">Asociar a Semilla (Opcional)</label>
            <select 
              id="tareaSemilla"
              value={semillaId}
              onChange={(e) => {
                setSemillaId(e.target.value);
                setVariedad(''); // Reset variety when seed changes
              }}
            >
              <option value="">-- General (Sin semilla) --</option>
              {seeds.map(s => (
                <option key={s.id} value={s.id}>{s.icon} {s.name}</option>
              ))}
            </select>
          </div>

          <div className="input-group">
            <label htmlFor="tareaAsignado">Asignar a (Opcional)</label>
            <select 
              id="tareaAsignado"
              value={asignadoA}
              onChange={(e) => setAsignadoA(e.target.value)}
            >
              <option value="">-- Sin asignar --</option>
              {hortelanos.map(h => (
                <option key={h.id} value={h.id}>
                  {h.sexo === 'M' ? '👨‍🌾' : '👩‍🌾'} {h.nombre}
                </option>
              ))}
            </select>
          </div>

          {selectedSeed && selectedSeed.varieties && selectedSeed.varieties.length > 0 && (
            <div className="input-group animate-fade">
              <label htmlFor="tareaVariedad">Variedad (Opcional)</label>
              <select 
                id="tareaVariedad"
                value={variedad}
                onChange={(e) => setVariedad(e.target.value)}
              >
                <option value="">-- Cualquiera --</option>
                {selectedSeed.varieties.map(v => (
                  <option key={v} value={v}>{v}</option>
                ))}
              </select>
            </div>
          )}

          <div style={{ marginTop: '24px' }}>
            <button type="submit" className="btn" disabled={!descripcion.trim() || !fecha}>
              Guardar Tarea
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
}
